import type { ComponentProps } from 'react';
import { useHistory } from '@/store/useHistory';
import { HistoryListItem } from './history-list-item';

interface HistoryListProps
  extends Pick<ComponentProps<typeof HistoryListItem>, 'onNavigateToHistory'> {
}

export function HistoryList({ onNavigateToHistory }: HistoryListProps) {
  const histories = useHistory((state) => state.histories);

  return (
    <ul className="flex flex-col gap-2 overflow-auto" aria-label="Saved sessions">
      {
        histories.length > 0
          ? (
              histories.map((history) => (
                <HistoryListItem
                  key={history.createdAt}
                  history={history}
                  onNavigateToHistory={onNavigateToHistory}
                />
              )))
          : (
              <li className="list-none text-center text-sm text-muted">
                No history found
              </li>
            )
      }
    </ul>
  );
}
